export default "__VITE_ASSET__BwNnfKbJ__"